import { useEffect, useRef, useState } from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";
import standardAttributeStores from "../../../Stores/StandardAttributeStores";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import StandardAttribute_Actions from "../../../Actions/StandardAttribute_Actions";
import commonUtils from "../../../helpers/commonUtils";
import EquipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import equipmentGroupStore from "../../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../../Constants/EquipmentGroupConstants";
import OverridePlantOptions from "./overridePlantOptions";
import StandardAttributeConstants from "../../../Constants/StandardAttributeConstants";
import AppConstants from "../../../Constants/AppConstants";

const AddStandardAttribute = (props) => {
  const {
    standardAttributeDetails,
    clearProps,
    closeEditStandardAttributePopUpCallback,
    attributeTypeList,
    queryResult,
  } = props;
  const [attributeName, setAttributeName] = useState("");
  const [attributeId, setAttributeId] = useState(AppConstants.DEFAULT_GUID);
  const [attributeType, setAttributeType] = useState("");
  const [attributeUnit, setAttributeUnit] = useState("");
  const [attributeNameDisplay, setAttributeNameDisplay] = useState("");
  const [attributeIsMandotry, setAttributeIsMandotry] = useState(false);
  const [attributeQuery, setAttributeQuery] = useState("");
  const [optionsList, setOptionsList] = useState("");
  const [equipmentGroupList, setEquipmentGroupList] = useState([]);
  const [selectedEquipmentGroup, setSelectedEquipmentGroup] = useState("");
  const [queryResultData, setQueryResultData] = useState([]);
  const [showQueryDataFilter, setShowQueryDataFilter] = useState(false);
  const OverridePlantOptionsRef = useRef(null);
  const [dropdownOptionSelected, setDropdownOptionSelected] = useState("no");

  const [typeDisable, setTypeDisable] = useState(false);
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();

  useEffect(() => {
    if (props.standardAttributeDetails) {
      setAttributeId(
        standardAttributeDetails.id
          ? standardAttributeDetails.id
          : AppConstants.DEFAULT_GUID,
      );
      setAttributeName(
        standardAttributeDetails.bezeichnung
          ? standardAttributeDetails.bezeichnung
          : "",
      );
      setAttributeType(
        standardAttributeDetails.type ? standardAttributeDetails.type : "",
      );
      setAttributeUnit(
        standardAttributeDetails.einheit
          ? standardAttributeDetails.einheit
          : "",
      );
      setAttributeNameDisplay(
        standardAttributeDetails.nameDisplay
          ? standardAttributeDetails.nameDisplay
          : "",
      );
      setAttributeIsMandotry(
        standardAttributeDetails.isMandatory === true
          ? standardAttributeDetails.isMandatory
          : false,
      );

      if (
        standardAttributeDetails.queryId &&
        standardAttributeDetails.queryId != "" &&
        standardAttributeDetails.queryId != 0
      ) {
        setDropdownOptionSelected("existing");
        setAttributeQuery(standardAttributeDetails.queryId);
      } else if (
        standardAttributeDetails.options &&
        standardAttributeDetails.options != ""
      ) {
        setDropdownOptionSelected("custom");
        setOptionsList(standardAttributeDetails.options);
      } else {
        setDropdownOptionSelected("no");
        setAttributeQuery("");
        setOptionsList("");
      }

      setTypeDisable(standardAttributeDetails.type ? true : false);
      commonUtils.setIsEdit(true);
    } else {
      setAttributeId(AppConstants.DEFAULT_GUID);
      setAttributeName("");
      setAttributeNameDisplay("");
      setAttributeType("");
      setAttributeUnit("");
      setAttributeIsMandotry(false);
      setTypeDisable(false);
      setAttributeQuery("");
      setDropdownOptionSelected("no");
      setOptionsList("");
      setShowQueryDataFilter(false);
      commonUtils.setIsEdit(false);
    }
  }, [standardAttributeDetails]);

  const getUserEquipmentGroups = () => {
    if (equipmentGroupList.length == 0) {
      setGlobalSpinner(true);
      EquipmentGroupActions.getOrganisationsEquipmentGroup();
    }
  };

  useEffect(() => {
    function getOrgEqGrpSuccess() {
      var res = equipmentGroupStore.getOrgEquipmentGroupResult();
      if (res.length > 0) {
        setEquipmentGroupList(res);
      } else {
        setEquipmentGroupList([]);
      }
      setGlobalSpinner(false);
    }

    function getOrgEqGrpFailure() {
      setEquipmentGroupList([]);
      setGlobalSpinner(false);
    }

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_ORG_EQUIPMENT_SUCCESS,
      getOrgEqGrpSuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_ORG_EQUIPMENT_FAILURE,
      getOrgEqGrpFailure,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_ORG_EQUIPMENT_SUCCESS,
        getOrgEqGrpSuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_ORG_EQUIPMENT_FAILURE,
        getOrgEqGrpFailure,
      );
    };
  }, []);

  const getQueryDataResult = () => {
    setGlobalSpinner(true);
    StandardAttribute_Actions.getQueryDataResult(
      attributeQuery,
      selectedEquipmentGroup,
    );
  };

  useEffect(() => {
    if (selectedEquipmentGroup != "") getQueryDataResult();

    return () => {};
  }, [selectedEquipmentGroup]);

  useEffect(() => {
    function getQueryDataResultSuccess() {
      var res = standardAttributeStores.getQueryDataResult();
      if (res.length > 0) {
        setQueryResultData(res);
      } else {
        setQueryResultData([]);
      }
      setGlobalSpinner(false);
    }

    function getQueryDataResultFailure() {
      setQueryResultData([]);
      setGlobalSpinner(false);
    }

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.GET_QUERY_DATA_RESULT_SUCCESS,
      getQueryDataResultSuccess,
    );

    standardAttributeStores.addChangeListener(
      StandardAttributeConstants.GET_QUERY_DATA_RESULT_FAILURE,
      getQueryDataResultFailure,
    );
    return () => {
      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.GET_QUERY_DATA_RESULT_SUCCESS,
        getQueryDataResultSuccess,
      );

      standardAttributeStores.removeChangeListener(
        StandardAttributeConstants.GET_QUERY_DATA_RESULT_FAILURE,
        getQueryDataResultFailure,
      );
    };
  }, []);

  function IsMandatoryValue(e) {
    e.preventDefault();
    if (e.target.value === "true") {
      setAttributeIsMandotry(true);
    } else {
      setAttributeIsMandotry(false);
    }
  }

  const handleCheckUncheckRadio = (e) => {
    e.persist();
    if (e.target.value === "existing") {
      setAttributeType("string");
      setTypeDisable(true);
      if (
        standardAttributeDetails.queryId &&
        standardAttributeDetails.queryId != "" &&
        standardAttributeDetails.queryId != 0
      ) {
        setAttributeQuery(standardAttributeDetails.queryId);
      } else {
        setAttributeQuery("");
      }
    } else if (e.target.value === "custom") {
      setAttributeType("string");
      setTypeDisable(true);
      if (
        standardAttributeDetails.options &&
        standardAttributeDetails.options != ""
      ) {
        setOptionsList(standardAttributeDetails.options);
      } else {
        setOptionsList("");
      }
    } else {
      if (props.standardAttributeDetails) {
        setAttributeType(
          standardAttributeDetails.type ? standardAttributeDetails.type : "",
        );
        setTypeDisable(true);
      } else {
        setTypeDisable(false);
      }
    }
    setDropdownOptionSelected(e.target.value);
  };

  useEffect(() => {
    if (dropdownOptionSelected === "existing") {
      setOptionsList("");
    } else if (dropdownOptionSelected === "custom") {
      setAttributeQuery("");
    } else {
      setOptionsList("");
      setAttributeQuery("");
    }
    return () => {};
  }, [dropdownOptionSelected]);

  function standardAttributecreate(e) {
    e.preventDefault();
    const standardAttributeData = {
      Bezeichnung: attributeName.trim(),
      ID: attributeId,
      Type: attributeType,
      Einheit: attributeUnit.trim(),
      NameDisplay:
        attributeNameDisplay == "" ? null : attributeNameDisplay.trim(),
      IsMandatory: attributeIsMandotry,
      QueryId: attributeQuery,
      Code: "",
      Options: optionsList,
    };
    setGlobalSpinner(true);
    StandardAttribute_Actions.saveUpdateStandardAttribute(
      standardAttributeData,
    );
  }

  function handleClosePopOver() {
    if (attributeId == AppConstants.DEFAULT_GUID) {
      setAttributeName("");
      setAttributeNameDisplay("");
      setAttributeType("");
      setAttributeUnit("");
      setAttributeIsMandotry(false);
      setAttributeQuery("");
      setDropdownOptionSelected("no");
      setOptionsList("");
      setTypeDisable(false);
      setShowQueryDataFilter(false);
    } else {
      clearProps();
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === ".") {
      event.preventDefault(); // Stop the dot from being entered
    }
  };

  const handleOnChange = (e) => {
    e.preventDefault();
    const newValue = e.target.value.replace(/\./g, "");
    if (newValue !== "") {
      setAttributeName(newValue);
    } else {
      setAttributeName(newValue.trim());
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="addStandardAttribute"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="addStandardAttribute"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="custom-modal modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addStandardAttribute">
                {standardAttributeDetails
                  ? localization.editStandardAttribute
                  : localization.addStandardAttribute}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="addStandardAttributeModalClose"
                onClick={handleClosePopOver}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <form
              id="createEquipmentGroupForm"
              name="createEquipmentGroupForm"
              onSubmit={standardAttributecreate}
            >
              <div className="modal-body">
                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <label className="form-label" htmlFor="name">
                        {localization.attributeName}
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        required
                        placeholder={localization.enterAttribute}
                        value={attributeName}
                        onKeyDown={handleKeyDown}
                        onChange={handleOnChange}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label" htmlFor="nameDisplay">
                        {localization.attributeNameDisplay}
                      </label>
                      <input
                        type="text"
                        id="nameDisplay"
                        name="nameDisplay"
                        className="form-control"
                        placeholder={localization.enterDisplayName}
                        value={attributeNameDisplay}
                        onChange={(e) => {
                          e.preventDefault();
                          if (attributeNameDisplay !== "") {
                            setAttributeNameDisplay(e.target.value);
                          } else {
                            setAttributeNameDisplay(e.target.value.trim());
                          }
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        {localization.selectDropDownOptions}
                      </label>
                      <div className="row">
                        <div className="col">
                          <div className="row">
                            <div className="col-1 pr-0 text-center">
                              <input
                                type="radio"
                                name="IsDropDown"
                                value="existing"
                                checked={dropdownOptionSelected === "existing"}
                                onChange={(e) => {
                                  handleCheckUncheckRadio(e);
                                }}
                              />
                            </div>
                            <div className="col p-0">
                              {localization.fromExistingList}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <div className="row">
                            <div className="col-1 pr-0 text-center">
                              <input
                                type="radio"
                                name="IsDropDown"
                                value="custom"
                                checked={dropdownOptionSelected === "custom"}
                                onChange={(e) => {
                                  handleCheckUncheckRadio(e);
                                }}
                              />
                            </div>
                            <div className="col p-0">
                              {localization.createCustomList}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <div className="row">
                            <div className="col-1 pr-0 text-center">
                              <input
                                type="radio"
                                name="IsDropDown"
                                value="no"
                                checked={dropdownOptionSelected === "no"}
                                onChange={(e) => {
                                  handleCheckUncheckRadio(e);
                                }}
                              />
                            </div>
                            <div className="col p-0">{localization.no}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="form-group">
                      <label className="form-label" htmlFor="Type">
                        {localization.dataType}
                      </label>
                      <select
                        className="form-control"
                        id="type"
                        name="type"
                        required
                        value={attributeType}
                        disabled={typeDisable}
                        onChange={(e) => {
                          setAttributeType(e.target.value);
                        }}
                      >
                        <option value="" disabled>
                          {localization.selectType}
                        </option>
                        <option value="bool">{localization.boolean}</option>
                        <option value="int">{localization.integer}</option>
                        <option value="string">{localization.string}</option>
                        <option value="datetime">
                          {localization.StandardAttrdateTime}
                        </option>
                        <option value="float">{localization.float}</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label className="form-label" htmlFor="mandatory">
                        {localization.global}
                      </label>
                      <select
                        className="form-control"
                        id="mandatory"
                        name="mandatory"
                        value={attributeIsMandotry}
                        onChange={(e) => {
                          IsMandatoryValue(e);
                        }}
                      >
                        <option value={true}>{localization.yes}</option>
                        <option value={false}>{localization.no}</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label" htmlFor="Unit">
                        {localization.attributeUnit}
                      </label>
                      <input
                        type="text"
                        id="Unit"
                        name="Unit"
                        className="form-control"
                        placeholder={localization.enterUnit}
                        value={attributeUnit}
                        onChange={(e) => {
                          e.preventDefault();
                          if (attributeUnit !== "") {
                            setAttributeUnit(e.target.value);
                          } else {
                            setAttributeUnit(e.target.value.trim());
                          }
                        }}
                      />
                    </div>
                    {dropdownOptionSelected === "existing" && (
                      <>
                        <div className="form-group">
                          <label htmlFor="Query" className="mr-3">
                            {localization.query}
                          </label>
                          <select
                            className="form-control"
                            id="Query"
                            name="Query"
                            required
                            value={attributeQuery}
                            onChange={(e) => {
                              setAttributeQuery(e.target.value);
                              setShowQueryDataFilter(false);
                            }}
                          >
                            <option value="" disabled>
                              {localization.selectQuery}
                            </option>
                            {props.queryResult.map((query, index) => {
                              return (
                                <option key={index} value={query.id}>
                                  {query.bezeichnung}
                                  {query.description}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        {attributeQuery ? (
                          <>
                            <div className="form-group">
                              <button
                                type="button"
                                name="showResult"
                                id="showResult"
                                className="btn btn-primary"
                                onClick={() => {
                                  getUserEquipmentGroups();
                                  setShowQueryDataFilter(true);
                                  setSelectedEquipmentGroup("");
                                  setQueryResultData([]);
                                }}
                              >
                                {localization.showQueryResult}
                              </button>
                            </div>
                            {showQueryDataFilter ? (
                              <>
                                <div className="form-group">
                                  {" "}
                                  <label
                                    htmlFor="equipmentGrpList"
                                    className="mr-3"
                                  >
                                    {
                                      localization.selectEquipmentGroupForQueryRes
                                    }
                                  </label>
                                  <select
                                    className="form-control"
                                    id="equipmentGrpList"
                                    name="equipmentGrpList"
                                    value={selectedEquipmentGroup}
                                    onChange={(e) => {
                                      setSelectedEquipmentGroup(e.target.value);
                                    }}
                                  >
                                    <option value="" disabled></option>
                                    {equipmentGroupList.map((eqpGrp, index) => {
                                      return (
                                        <option key={index} value={eqpGrp.id}>
                                          {eqpGrp.bezeichnungsDisplay}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                                <div className="form-group">
                                  {" "}
                                  <label
                                    htmlFor="queryDataResultList"
                                    className="mr-3"
                                  >
                                    {localization.queryResult}
                                  </label>
                                  <select
                                    className="form-control"
                                    id="queryDataResultList"
                                    name="queryDataResultList"
                                  >
                                    {queryResultData.map((data, index) => {
                                      return (
                                        <option key={index} value={data.value}>
                                          {data.label}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                    {dropdownOptionSelected === "custom" && (
                      <div className="form-group">
                        <label htmlFor="customListOptions" className="mr-3">
                          {localization.enterCustomListOptions}
                        </label>

                        <textarea
                          rows={10}
                          cols={10}
                          id="customListOptions"
                          name="customListOptions"
                          className="form-control"
                          required
                          placeholder={localization.enterOptionsLike}
                          value={optionsList}
                          onChange={(e) => {
                            setOptionsList(e.target.value);
                          }}
                        />
                        <div>
                          {standardAttributeDetails &&
                          standardAttributeDetails.options != null &&
                          standardAttributeDetails.options != "" ? (
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                OverridePlantOptionsRef.current.handleLoadOptions(
                                  props.standardAttributeDetails.id,
                                );
                              }}
                              data-toggle="modal"
                              data-target="#overridePlantOptionsModal"
                            >
                              <b>{localization.plantSpecificOptions}</b>
                            </span>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="form-group marProp">
                  <button
                    type="submit"
                    className="btn btn-primary btn-block mb-4"
                  >
                    {localization.save}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <OverridePlantOptions ref={OverridePlantOptionsRef} />
    </>
  );
};

export default AddStandardAttribute;
